// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import ButtonVisitChoice from './logic'

export default function ButtonVisitChoiceFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/ButtonVisitChoice">
      <ButtonVisitChoice {...props}>
        {children}
      </ButtonVisitChoice>
    </Flow>
  )
}
